(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-watch-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('es-watch-quiz')) {
  customElements.define('es-watch-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.step = 0;
      this.form = this.querySelector('form');
      this.steps = Array.from(this.querySelectorAll('fieldset'));
      this.result = this.querySelector('.es-quiz__result');
      this.back = this.querySelector('[data-back]');
      this.next = this.querySelector('[data-next]');
      this.error = this.querySelector('[role="alert"]');
      this.form.noValidate = true;
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        if (!this.steps[this.step].querySelector('input:checked')) {
          this.error.hidden = false;
          this.steps[this.step].querySelector('input').focus();
          return;
        }
        this.error.hidden = true;
        if (this.step < 2) { this.step++; this.showStep(); }
        else this.showResult();
      });
      this.back.addEventListener('click', () => { if(this.step>0){this.step--;this.showStep();} });
      this.querySelector('[data-restart]').addEventListener('click', () => {
        this.form.reset(); this.step=0; this.result.hidden=true;this.form.hidden=false;this.showStep();
      });
    }
    showStep() {
      this.error.hidden=true;
      this.steps.forEach((s,i)=>{s.hidden=i!==this.step;});
      this.back.hidden=this.step===0;
      this.next.textContent=this.step===2?'Find my watch':'Next question';
      this.querySelector('.es-quiz__progress').textContent='Question '+(this.step+1)+' of 3';
      const legend=this.steps[this.step].querySelector('legend');
      legend.tabIndex=-1;legend.focus();
    }
    showResult() {
      const answers = new FormData(this.form);
      const style=answers.get('style'), colour=answers.get('colour'), occasion=answers.get('occasion');
      const score={legacy:0,orvian:0,aureon:0};
      score[style]+=3;score[occasion]+=2;
      score[{warm:'legacy',cool:'aureon',contrast:'orvian'}[colour]]+=1;
      const winner=Object.keys(score).sort((a,b)=>score[b]-score[a]||(a===style?-1:b===style?1:0))[0];
      const collections={
        legacy:{title:'Your match: Legacy',description:'Your answers lean toward tailored style and considered details. Explore Legacy’s round chronograph designs and leather straps.',url:'/collections/legacy-collection'},
        orvian:{title:'Your match: Orvian',description:'Your answers favour individuality and relaxed style. Explore Orvian’s distinctive rectangular designs and silicone straps.',url:'/collections/orvian-collection'},
        aureon:{title:'Your match: Aureon',description:'Your answers point toward bold, sport-inspired styling. Explore Aureon’s chronograph designs and silicone straps.',url:'/collections/aureon-collection'}
      };
      const match=collections[winner];
      this.querySelector('[data-result-title]').textContent=match.title;
      this.querySelector('[data-result-description]').textContent=match.description;
      this.querySelector('[data-result-colour]').textContent={warm:'Look for warm gold finishes as you browse.',cool:'Look for silver and blue finishes as you browse.',contrast:'Explore contrasting dials and statement colours as you browse.'}[colour];
      const link=this.querySelector('[data-result-link]');link.href=match.url;link.textContent='Explore '+winner.charAt(0).toUpperCase()+winner.slice(1);
      this.form.hidden=true;this.result.hidden=false;this.result.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-watch-spins"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('es-watch-narration')) {
  class ESWatchNarration extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.video || !this.button) return;
      this.initialized = true;
      this.listening = false;
      this.video.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.listen();
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.stop();
      });
      this.button.addEventListener('click', () => {
        if (this.listening) this.stop();
        else this.listen();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.stop();
      });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.stop();
      });
      this.video.addEventListener('volumechange', () => {
        if (this.video.muted) this.render(false);
      });
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) this.video.pause();
    }
    render(active) {
      this.button.setAttribute('aria-pressed', String(active));
      this.button.textContent = active ? this.dataset.mute : this.dataset.listen;
      this.button.setAttribute('aria-label', this.button.textContent + ': ' + this.dataset.title);
    }
    async listen() {
      if (this.listening) return;
      document.querySelectorAll('es-watch-narration').forEach(other => {
        if (other !== this && typeof other.stop === 'function') other.stop();
      });
      this.listening = true;
      this.video.currentTime = 0;
      this.video.muted = false;
      this.render(true);
      try {
        await this.video.play();
        if (this.listening) this.status.textContent = this.dataset.playing;
      } catch {
        if (!this.listening) return;
        this.stop();
        this.status.textContent = this.dataset.blocked;
        this.video.play().catch(() => {});
      }
    }
    stop() {
      this.listening = false;
      this.video.muted = true;
      this.render(false);
      this.status.textContent = '';
    }
    disconnectedCallback() {
      if (this.video) this.stop();
    }
  }
  customElements.define('es-watch-narration', ESWatchNarration);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
